import Script from "next/script"
import { getGlobals } from "storyblok/api"
import { getOfficePaths, getOffice } from "storyblok/offices"
import Meta from "components/Meta"
import LocationPageHeader from "components/Archive/LocationPageHeader"
import DynamicComponent from "components/DynamicComponent"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function Article({ story, socialMedia, meta }) {
  return (
    <>
      <Meta info={meta} />
      <StoryblokVisualEditor story={story?.content}>
        <main data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="4">
          <LocationPageHeader
            blok={{
              ...story?.content,
              heading: story?.content?.name,
              address: story?.content?.address?.address,
              lat: parseFloat(story?.content?.address?.lat),
              lng: parseFloat(story?.content?.address?.lng),
              image: story?.content?.image,
              breadcrumbs: [{ text: "Locations Served", href: "/offices" }, { text: story?.content?.name }],
            }}
          />
          {story?.content?.body?.length
            ? story?.content?.body.map((blok) => <DynamicComponent blok={blok} key={blok._uid} />)
            : null}
        </main>
      </StoryblokVisualEditor>
      <Script type="application/ld+json" id="office-schema">
        {`{
          "@context": "https://schema.org",
          "@type": "LegalService",
          "url": "https://www.husbandandwifelawteam.com",
          "sameAs": [${Object?.values(socialMedia).map(
            (link, idx) => `"${link}"${Object?.values(socialMedia).length - 1 < idx ? `, ` : ``}`,
          )}],
        "name" : "The Husband & Wife Law Team",
        "email": "",
        "address": {
          "@type": "PostalAddress",
        "streetAddress": "${story?.content?.address?.address}"
          },
        "telephone": "${story?.content?.phone}"
        }`}
      </Script>
    </>
  )
}

export async function getStaticProps({ params: { office }, preview = null }) {
  const globals = await getGlobals()
  const story = await getOffice(`offices/${office}`, preview)

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getOfficePaths(),
    fallback: false,
  }
}
